import React, { Fragment } from 'react'
import 'moment/locale/ja'
import {
  getUserName,
  getLastStatus,
  getMamorioImageSrc,
  getLostFoundStatus,
} from '../../helpers/CommonMamorioHelper'
import { getFromNowAsText } from '../../helpers/timeHelper'
import {
  getStaleDetectionWarningColor,
  getStaleDetectionWarningMessage,
  shouldShowStaleDetectionWarning,
  type StaleDetectionWarningConfig,
} from '../../helpers/staleDetectionWarning'
import { itemIcon } from '../../icons'
import { showLostAndBattery } from '../../modules/common/session'
import LastEventLogSummary from '../common/LastEventLogSummary'
import BatteryRemaining from '../common/BatteryRemaining'

type Props = {
  mamorio: IMamorio
  onClickList: (arg: any | void) => void
  memoEnabled: boolean
  staleDetectionWarningConfig?: StaleDetectionWarningConfig | null
  lastEventLogEnabled?: boolean
  dividerColSpan?: number
}

const MamoriosListItem = ({
  mamorio,
  onClickList,
  memoEnabled,
  staleDetectionWarningConfig,
  lastEventLogEnabled = false,
  dividerColSpan = 6,
}: Props) => {
  const recentLog = mamorio.recent_log
  const shouldShowWarning = shouldShowStaleDetectionWarning(
    recentLog?.at,
    staleDetectionWarningConfig,
  )

  return (
    <Fragment key={mamorio.id + Math.round(Math.random() * 10000).toString()}>
      <tr
        className="list-row overview-item-list-item"
        key={mamorio.id.toString()}
        onClick={onClickList}
      >
        {/* ----- アイテム名 ----- */}
        <td className="item item-name">
          <div className="img-name-item">
            <img className="item-icon" src={getMamorioImageSrc(mamorio)} alt="mamorio" onError={(e) => { e.currentTarget.src = itemIcon }} />
            <div>
              <strong className="item-name-text">
                {mamorio.name}
              </strong>
              <br />
              <span className="item-majorminor-text" style={{ fontSize: '12px', color: '#757575' }}>
                {`${mamorio.major}-${mamorio.minor}`}
              </span>
            </div>
          </div>
        </td>

        {memoEnabled && (
          <td className="item item-detected-by">
            <div className="img-name-item">
             {mamorio.memo ? mamorio.memo : '-'}
            </div>
          </td>
        )}

        {/* ----- 最終検知時刻 ----- */}
        <td
          className={`item item-last-detected-at${shouldShowWarning ? ' stale-detection-warning' : ''}`}
          style={shouldShowWarning ? { color: getStaleDetectionWarningColor(staleDetectionWarningConfig) } : undefined}
        >
          <div>
            {recentLog ? getFromNowAsText(recentLog.at) : '-'}
          </div>
          {shouldShowWarning && (
            <div
              className="stale-detection-warning-message"
              style={{ fontSize: '14px' }}
            >
              {getStaleDetectionWarningMessage(staleDetectionWarningConfig)}
            </div>
          )}
        </td>

        {/* ----- 検知した端末 ----- */}
        <td className="item item-detected-by">
          <div className="img-name-item">
            <img className="item-icon" src={getLastStatus(mamorio).imgSrc} style={{ borderRadius: 0 }} alt="status" />
            <div className="status">
              <div className="main item-detected-by-text">
                {getLastStatus(mamorio).text}
              </div>
            </div>
          </div>
        </td>

        {lastEventLogEnabled && (
          <td className="item item-last-event-log">
            <LastEventLogSummary lastEventLog={mamorio.last_event_log} />
          </td>
        )}

        {/* ----- バッテリー残量 ----- */}
        <td className="item item-detected-by">
          <BatteryRemaining percentage={mamorio.estimated_remain_battery} />
        </td>

        {/* ----- 紛失ステータス ----- */}
        {showLostAndBattery() && (
          <td className="item item-detected-by">
            <div className="img-name-item">
              {getLostFoundStatus(mamorio)}
            </div>
          </td>
        )}

        {/* ----- 所持者 ----- */}
        <td className="item">
          <div className="status">
            <div className="main">
              {mamorio.is_rent
                ? (
                  <div className="sub">
                    <div className="status-rental rental">
                      持出中
                    </div>
                    <div className="rental-owner">
                      {mamorio.user ? getUserName(mamorio.user) : '所有者がいません'}
                    </div>
                  </div>
                )
                : (
                  <div className="sub">
                    <span className="rental-owner">
                      { mamorio.user ? getUserName(mamorio.user) : '-' }
                    </span>
                  </div>
                )}
            </div>
          </div>
        </td>
      </tr>

      <tr key={`divider-${mamorio.id}`} className="divider">
        <td colSpan={dividerColSpan}>
          <div className="line" />
        </td>
      </tr>
    </Fragment>
  )
}

export default MamoriosListItem
